// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/background.jpeg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#main-guardian-dark-container {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-attachment: fixed;
  font-family: "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
#main-guardian-dark-container .text-black,
#main-guardian-dark-container .nav-link,
#main-guardian-dark-container .dropdown-item {
  color: #e8e8e8 !important;
}
#main-guardian-dark-container .nav-pills .nav-link.active {
  color: #c6c6c6;
}
#main-guardian-dark-container .cds--tabs .cds--tabs__nav-item--selected {
  color: #c6c6c6;
}
#main-guardian-dark-container input,
#main-guardian-dark-container select,
#main-guardian-dark-container textarea {
  background-color: #262626;
  color: #c6c6c6;
}
#main-guardian-dark-container .card {
  background-color: rgba(22, 22, 22, 0.8509803922);
  border: 1px solid rgba(22, 22, 22, 0.8509803922);
  opacity: 0.9;
  color: #c1c7cd;
}
#main-guardian-dark-container .card #login_card {
  background-color: #121619 !important;
  border: none;
}
#main-guardian-dark-container .card #login_card .shadow-lg {
  box-shadow: none !important;
}
#main-guardian-dark-container .card #login_card .nav-pills .nav-link.active,
#main-guardian-dark-container .card #login_card .nav-pills .show > .nav-link,
#main-guardian-dark-container .card #login_card .btn-secondary {
  background: var(--bs-gray) !important;
  color: var(--bs-light) !important;
  border: none !important;
}
#main-guardian-dark-container .card #login_card .nav-pills .nav-link.active .nav-item,
#main-guardian-dark-container .card #login_card .nav-pills .show > .nav-link .nav-item,
#main-guardian-dark-container .card #login_card .btn-secondary .nav-item {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}
#main-guardian-dark-container .card #login_card .cds--checkbox-label::before {
  background-color: var(--bs-gray);
}
#main-guardian-dark-container .card #login_card .cds--list__item {
  color: var(--bs-white);
}
#main-guardian-dark-container .card #copy_rights {
  text-align: center;
}
#main-guardian-dark-container .guardian-panel {
  height: 100vh;
  width: 100vw;
  margin-left: 0;
}
#main-guardian-dark-container .guardian-panel .logo-panel {
  padding: 0;
}
#main-guardian-dark-container .guardian-panel .content-panel {
  box-sizing: border-box;
}
#main-guardian-dark-container .guardian-panel .content-panel .tabs-container {
  margin-left: 5.5rem;
}
#main-guardian-dark-container .guardian-panel img.logo-image {
  align-self: center;
  height: 20vh;
}
#main-guardian-dark-container .guardian-panel .logo_style {
  max-height: 10em;
}
#main-guardian-dark-container .guardian-panel .recoveryLink {
  text-decoration: none;
}
#main-guardian-dark-container .guardian-panel .tile-container {
  padding: 0.5rem 0;
}`, "",{"version":3,"sources":["webpack://./src/utils/GuardianPanelDark.scss"],"names":[],"mappings":"AAEA;EACI,yDAAA;EACA,sBAAA;EACA,4BAAA;EACA,2IAAA;AADJ;AAUI;;;EAGI,yBAAA;AARR;AAYQ;EACI,cAAA;AAVZ;AAeQ;EACI,cAAA;AAbZ;AAiBI;;;EAGI,yBAAA;EACA,cAAA;AAfR;AAkBI;EACI,gDAAA;EACA,gDAAA;EACA,YAAA;EACA,cAAA;AAhBR;AAkBQ;EACI,oCAAA;EACA,YAAA;AAhBZ;AAkBY;EACI,2BAAA;AAhBhB;AAmBY;;;EAGI,qCAAA;EACA,iCAAA;EACA,uBAAA;AAjBhB;AAmBgB;;;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;AAfpB;AAoBgB;EACI,gCAAA;AAlBpB;AAsBY;EACI,sBAAA;AApBhB;AAwBQ;EACI,kBAAA;AAtBZ;AA0BI;EACI,aAAA;EACA,YAAA;EACA,cAAA;AAxBR;AA0BQ;EACI,UAAA;AAxBZ;AA2BQ;EACI,sBAAA;AAzBZ;AA2BY;EACI,mBAAA;AAzBhB;AA4BQ;EACI,kBAAA;EACA,YAAA;AA1BZ;AA6BQ;EACI,gBAAA;AA3BZ;AA8BQ;EACI,qBAAA;AA5BZ;AA+BQ;EACI,iBAAA;AA7BZ","sourcesContent":["@import '../scss/styles';\n\n#main-guardian-dark-container {\n    background-image: url('../assets/images/background.jpeg');\n    background-size: cover;\n    background-attachment: fixed;\n    font-family: \"Helvetica Neue\",\n        Arial,\n        \"Noto Sans\",\n        sans-serif,\n        \"Apple Color Emoji\",\n        \"Segoe UI Emoji\",\n        \"Segoe UI Symbol\",\n        \"Noto Color Emoji\";\n\n    .text-black,\n    .nav-link,\n    .dropdown-item {\n        color: #e8e8e8 !important;\n    }\n\n    .nav-pills {\n        .nav-link.active {\n            color: #c6c6c6;\n        }\n    }\n\n    .cds--tabs {\n        .cds--tabs__nav-item--selected {\n            color: #c6c6c6;\n        }\n    }\n\n    input,\n    select,\n    textarea {\n        background-color: #262626;\n        color: #c6c6c6;\n    }\n\n    .card {\n        background-color: #161616d9;\n        border: 1px solid #161616d9;\n        opacity: 0.9;\n        color: #c1c7cd;\n\n        #login_card {\n            background-color: #121619 !important;\n            border: none;\n\n            .shadow-lg {\n                box-shadow: none !important;\n            }\n\n            .nav-pills .nav-link.active,\n            .nav-pills .show>.nav-link,\n            .btn-secondary {\n                background: var(--bs-gray) !important;\n                color: var(--bs-light) !important;\n                border: none !important;\n\n                .nav-item {\n                    font-size: 1rem;\n                    font-weight: 400;\n                    line-height: 1.5;\n                }\n            }\n\n            .cds--checkbox-label {\n                &::before {\n                    background-color: var(--bs-gray);\n                }\n            }\n\n            .cds--list__item {\n                color: var(--bs-white)\n            }\n        }\n\n        #copy_rights {\n            text-align: center;\n        }\n    }\n\n    .guardian-panel {\n        height: 100vh;\n        width: 100vw;\n        margin-left: 0;\n\n        .logo-panel {\n            padding: 0;\n        }\n\n        .content-panel {\n            box-sizing: border-box;\n\n            .tabs-container {\n                margin-left: 5.5rem;\n            }\n        }\n        img.logo-image {\n            align-self: center;\n            height: 20vh;\n        }\n\n        .logo_style {\n            max-height: 10em;\n        }\n\n        .recoveryLink {\n            text-decoration: none;\n        }\n\n        .tile-container {\n            padding: 0.5rem 0;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
